import { TModifierGroupsAction, ModifierGroupsActionTypes } from './modifierGroupsActions';
import { IModifierGroupsState } from './modifierGroupsContext';

export const modifierGroupsReducer = (
	state: IModifierGroupsState,
	action: TModifierGroupsAction,
): IModifierGroupsState => {
	switch (action.type) {
		case ModifierGroupsActionTypes.SET_MODIFIER_GROUPS:
			return {
				...state,
				modifiersGroups: action.payload.modifiersGroups,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupsActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ModifierGroupsActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ModifierGroupsActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupsActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
